module.exports = __webpack_public_path__ + "654f7fd1ff3dacbbdaaeca8708561c19.png";